import Badge, { statusTone, priorityTone } from '@/components/base/Badge';
import EmptyState from '@/components/base/EmptyState';
import type { QuoteRequest } from '@/types';

export default function RequestList({
  requests,
  onSelect,
}: {
  requests: QuoteRequest[];
  onSelect: (r: QuoteRequest) => void;
}) {
  if (requests.length === 0) {
    return (
      <div className="rounded-lg border border-background-200 bg-white">
        <EmptyState
          icon="ri-file-list-3-line"
          title="Talepler bulunamadı."
          description="Filtreleri değiştirin veya yeni bir talep oluşturun."
        />
      </div>
    );
  }

  return (
    <>
      {/* Desktop table */}
      <div className="hidden overflow-hidden rounded-lg border border-background-200 bg-white md:block">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[1080px] text-left text-sm">
            <thead>
              <tr className="border-b border-background-100 text-xs font-semibold uppercase tracking-wide text-foreground-400">
                <th className="px-4 py-3">Müşteri</th>
                <th className="px-4 py-3">Telefon</th>
                <th className="px-4 py-3">Hizmet</th>
                <th className="px-4 py-3">Bölge</th>
                <th className="px-4 py-3">Talep Tarihi</th>
                <th className="px-4 py-3">Video</th>
                <th className="px-4 py-3">Durum</th>
                <th className="px-4 py-3">Kaynak</th>
                <th className="px-4 py-3">Sorumlu</th>
                <th className="px-4 py-3">Son İletişim</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((r) => (
                <tr
                  key={r.id}
                  onClick={() => onSelect(r)}
                  className="cursor-pointer border-b border-background-100 transition-colors hover:bg-background-50"
                >
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <span className="font-semibold text-foreground-900">{r.customerName}</span>
                      <Badge tone={priorityTone(r.priority)}>{r.priority}</Badge>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-foreground-600">{r.phone}</td>
                  <td className="px-4 py-3 text-foreground-600">{r.service}</td>
                  <td className="px-4 py-3 text-foreground-600">{r.region}</td>
                  <td className="px-4 py-3 text-foreground-500">{r.requestDate}</td>
                  <td className="px-4 py-3">
                    <Badge tone={statusTone(r.videoStatus)}>{r.videoStatus}</Badge>
                  </td>
                  <td className="px-4 py-3">
                    <Badge tone={statusTone(r.status)}>{r.status}</Badge>
                  </td>
                  <td className="px-4 py-3 text-foreground-500">{r.source}</td>
                  <td className="px-4 py-3 text-foreground-500">{r.responsible}</td>
                  <td className="px-4 py-3 text-foreground-500">{r.lastContact}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile cards */}
      <div className="space-y-3 md:hidden">
        {requests.map((r) => (
          <button
            key={r.id}
            type="button"
            onClick={() => onSelect(r)}
            className="w-full rounded-lg border border-background-200 bg-white p-4 text-left"
          >
            <div className="flex items-start justify-between gap-2">
              <div>
                <div className="font-heading text-base font-bold text-foreground-950">{r.customerName}</div>
                <div className="text-sm text-foreground-500">{r.service}</div>
              </div>
              <Badge tone={statusTone(r.status)}>{r.status}</Badge>
            </div>
            <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <span>{r.region}</span>
              <span>·</span>
              <span>{r.requestDate}</span>
            </div>
            <div className="mt-3 flex flex-wrap items-center gap-2">
              <Badge tone={statusTone(r.videoStatus)}>{r.videoStatus}</Badge>
              <Badge tone={priorityTone(r.priority)}>{r.priority}</Badge>
            </div>
            <div className="mt-3 flex items-center gap-1 text-xs font-semibold text-primary-600">
              Detayı Aç
              <i className="ri-arrow-right-s-line" />
            </div>
          </button>
        ))}
      </div>
    </>
  );
}